/**
 * 로그인 상태에 따라 헤더의 인증 버튼을 동적으로 변경
 * 로그인 시: 회원 이름 표시 (마이페이지 링크)
 * 로그아웃 시: 로그인/회원가입 버튼 표시
 */
(function() {
  'use strict';
  
  function updateAuthButtons() {
    // 로그인 상태 확인
    const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
    const custNm = sessionStorage.getItem('custNm') || '';
    const custId = sessionStorage.getItem('custId') || '';
    
    // auth-buttons 요소 찾기 (헤더가 로드될 때까지 대기)
    const checkAndUpdate = () => {
      const authButtonsContainer = document.querySelector('.auth-buttons');
      
      if (!authButtonsContainer) {
        return false;
      }
      
      if (isLoggedIn && custNm) {
        // 로그인 상태: 회원 이름 표시
        authButtonsContainer.innerHTML = `
          <a href="javascript:void(0)" onclick="navigateToMyPage()" class="btn-user" title="${custNm}님 마이페이지로 이동">
            <svg class="user-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
            </svg>
            <span class="user-id">${custNm}님</span>
          </a>
          <button onclick="handleLogout()" class="btn-logout" title="로그아웃">
            로그아웃
          </button>
        `;
      } else {
        // 로그아웃 상태: 로그인/회원가입 버튼 표시
        authButtonsContainer.innerHTML = `
          <a href="javascript:void(0)" onclick="navigateToLogin()" class="btn-login">로그인</a>
          <a href="javascript:void(0)" onclick="navigateToSignup()" class="btn-signup">회원가입</a>
        `;
      }
      
      return true;
    };
    
    // 즉시 시도
    if (!checkAndUpdate()) {
      // 헤더 로드를 기다림
      const observer = new MutationObserver((mutations, obs) => {
        if (checkAndUpdate()) {
          obs.disconnect();
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // 타임아웃 설정 (최대 5초)
      setTimeout(() => {
        observer.disconnect();
        checkAndUpdate();
      }, 5000);
    }
  }
  
  // 전역 네비게이션 함수들
  window.navigateToMyPage = function() {
    if (window.vueRouter) {
      window.vueRouter.push('/mypage/so_c4010');
    } else {
      window.location.hash = '#/mypage/so_c4010';
    }
  };
  
  window.navigateToLogin = function() {
    if (window.vueRouter) {
      window.vueRouter.push('/auth/login');
    } else {
      window.location.hash = '#/auth/login';
    }
  };
  
  window.navigateToSignup = function() {
    if (window.vueRouter) {
      window.vueRouter.push('/auth/signup');
    } else {
      window.location.hash = '#/auth/signup';
    }
  };
  
  // 전역 로그아웃 함수
  window.handleLogout = function() {
    if (confirm('로그아웃 하시겠습니까?')) {
      // auth-check.js의 clearUserInfo 호출
      if (window.clearUserInfo) {
        window.clearUserInfo();
      } else {
        // fallback: 직접 sessionStorage 삭제
        sessionStorage.clear();
      }
      
      alert('로그아웃이 완료되었습니다.');
      if (window.vueRouter) {
        window.vueRouter.push('/auth/login');
      } else {
        window.location.hash = '#/auth/login';
      }
      updateAuthButtons();
    }
  };
  
  // DOM 로드 완료 후 실행
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAuthButtons);
  } else {
    updateAuthButtons();
  }
  
  // 페이지 표시 시에도 실행 (뒤로가기 등)
  window.addEventListener('pageshow', updateAuthButtons);
  
  // authUpdate 커스텀 이벤트 리스너
  window.addEventListener('authUpdate', function(event) {
    updateAuthButtons();
  });
  
  // storage 이벤트 리스너 (다른 탭에서 로그인/로그아웃 시)
  window.addEventListener('storage', updateAuthButtons);
  
  // hashchange 이벤트 리스너 (Vue Router 라우트 변경 시)
  window.addEventListener('hashchange', updateAuthButtons);
  
})();
